"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalTitleSize = exports.ModalStatus = exports.ModalSize = void 0;
var ModalSize;
(function (ModalSize) {
    ModalSize["TrueFullScreen"] = "true-full-screen";
    ModalSize["FullScreen"] = "full-screen";
    ModalSize["Large"] = "lg";
    ModalSize["Small"] = "sm";
})(ModalSize = exports.ModalSize || (exports.ModalSize = {}));
var ModalStatus;
(function (ModalStatus) {
    ModalStatus["Danger"] = "danger";
    ModalStatus["Info"] = "info";
    ModalStatus["Success"] = "success";
    ModalStatus["Warning"] = "warning";
})(ModalStatus = exports.ModalStatus || (exports.ModalStatus = {}));
var ModalTitleSize;
(function (ModalTitleSize) {
    ModalTitleSize["Large"] = "large";
    ModalTitleSize["Small"] = "small";
})(ModalTitleSize = exports.ModalTitleSize || (exports.ModalTitleSize = {}));
//# sourceMappingURL=types.js.map